import { ErrorPage } from '@exploration/pages-error';
import { logger } from '@thrivent-web/logging-utils';
import { Component, ErrorInfo } from 'react';

// --------------------------------------------------------------------------

type ErrorBoundaryProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any;
};
type ErrorBoundaryState = {
  hasError: boolean;
};

// --------------------------------------------------------------------------

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.error('ErrorBoundary caught error', error, errorInfo);
  }
  render() {
    // No errors, we just pass through
    if (!this?.state?.hasError) {
      return this.props.children;
    }

    // Make an attempt to show our hardcoded fallback data if it's been made available
    if (this?.props?.children?.props?.fallbackData) {
      logger.warn(
        'showing fallbackData',
        this.props.children.props.fallbackData,
      );
      return {
        ...this.props.children,
        props: {
          ...this.props.children.props.fallbackData,
        },
      };
    }

    // Otherwise just fall back to the full on fail page
    return <ErrorPage title="Oops! Sorry, we encountered an error" />;
  }
}

// --------------------------------------------------------------------------

export default ErrorBoundary;
